/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import StretchEnum from '../../stretch/stretch-enum';

/**
 * Komunikátor roztažení média pro Ki-Wi Server.
 */
class CommunicatorStretch {
  /**
   * Zpracuje roztažení média.
   * @param {string} [value] Roztažení ve formátu, který vrací server.
   * @returns {StretchEnum|null} Roztažení média.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 'fill':
        result = StretchEnum.FILL;
        break;
      case 'uniform':
        result = StretchEnum.CONTAIN;
        break;
      case 'uniformToFill':
        result = StretchEnum.COVER;
        break;
      default:
        result = null;
    }
    return result;
  }
}

export default CommunicatorStretch;
